import React from "react";
import { Grid2, Stack } from "@mui/material";
import TextInput from "../../../input/TextInput";
import { FieldErrors, FieldValues, UseFormRegister } from "react-hook-form";
import CollapseSection from "../../../collapse/CollapseSection";

interface IInfoSection {
  register: UseFormRegister<FieldValues>;
  errors: FieldErrors<any>;
}

function InfoSection({ register, errors }: IInfoSection) {
  return (
    <CollapseSection title="Thông tin chung" show>
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 6 }}>
          <Stack gap={2}>
            <TextInput
              required
              multiline={false}
              label="Mã KLS/CLS"
              id="ma_khoa"
              name="ma_khoa"
              labelWidth="25%"
              placeholder="Nhập mã khoa lâm sàn, cận lâm sàn"
              register={register}
              errorMessage={errors?.ma_khoa?.message as string}
            />
            <TextInput
              multiline
              label="STT"
              id="stt"
              name="stt"
              labelWidth="25%"
              placeholder="Nhập số thứ tự"
              register={register}
            />
            <TextInput
              multiline
              label="Tên hoạt chất "
              id="hoat_chat"
              name="hoat_chat"
              labelWidth="25%"
              placeholder="Nhập tên hoạt chất "
              register={register}
            />
            <TextInput
              multiline
              label="Tên thương mại"
              id="ten_thuong_mai"
              name="ten_thuong_mai"
              labelWidth="25%"
              placeholder="Nhập tên thương mại"
              register={register}
            />
            <TextInput
              multiline
              label="Nồng độ, hàm lượng"
              id="ham_luong"
              name="ham_luong"
              labelWidth="25%"
              placeholder="Nhập nồng độ, hàm lượng"
              register={register}
            />
            <TextInput
              multiline
              label="Dạng bào chế"
              id="dang_bao_che"
              name="dang_bao_che"
              labelWidth="25%"
              placeholder="Nhập dạng bào chế"
              register={register}
            />
            <TextInput
              multiline
              label="Đường dùng"
              id="duong_dung"
              name="duong_dung"
              labelWidth="25%"
              placeholder="Nhập đường dùng"
              register={register}
            />
          </Stack>
        </Grid2>
        <Grid2 size={{ xs: 6 }}>
          <Stack gap={2}>
            <TextInput
              multiline
              label="Nhóm"
              id="nhom"
              name="nhom"
              labelWidth="25%"
              placeholder="Nhập nhóm"
              register={register}
            />
            <TextInput
              multiline
              label="Đơn vị tính"
              id="dvt"
              name="dvt"
              labelWidth="25%"
              placeholder="Nhập Đơn vị tính"
              register={register}
            />
            <TextInput
              multiline
              label="Số lượng dự trù"
              id="sl_dutru"
              name="sl_dutru"
              labelWidth="25%"
              placeholder="Nhập số lượng dự trù"
              register={register}
            />
            <TextInput
              multiline
              label="Nhà sản xuất"
              id="nsx"
              name="nsx"
              labelWidth="25%"
              placeholder="Nhập nhà sản xuất (nếu có thông tin)"
              register={register}
            />
            <TextInput
              multiline
              label="Nhà cung cấp"
              id="ncc"
              name="ncc"
              labelWidth="25%"
              placeholder="Nhập nhà cung cấp (nếu có thông tin)"
              register={register}
            />
            <TextInput
              multiline
              label="Lý do dự trù"
              id="ly_do"
              name="ly_do"
              labelWidth="25%"
              placeholder="Nhập lý do dự trù"
              register={register}
            />
            <TextInput
              label="ID thuốc"
              id="id_thuoc"
              name="id_thuoc"
              labelWidth="25%"
              placeholder="Nhập ID thuốc"
              register={register}
            />
          </Stack>
        </Grid2>
      </Grid2>
    </CollapseSection>
  );
}

export default InfoSection;
